import RejectedIcon from './RejectedIcon';

export default RejectedIcon;
